import React, {ReactNode} from 'react';

import {ElementMouseEvent} from 'util/Types';

import {Cell} from './SimpleTable';

export interface LinkCellProps {
  children?: ReactNode;
  onClick: (e: ElementMouseEvent) => void;
}

export default function LinkCell(props: LinkCellProps): JSX.Element {
  return (
    <Cell>
      <a onClick={props.onClick}>{props.children}</a>
    </Cell>
  );
}

LinkCell.defaultProps = {
  onClick: () => {},
};
